import React from 'react'
import { useTranslation } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ChangeTemporaryPasswordForm from '../components/form/ChangeTemporaryPasswordForm'
import { changeTemporaryPassword } from '../store/passwordRecovery/actions'

const ChangeTemporaryPasswordPage = ({ match, lang }) => {
  const { t } = useTranslation()

  return (
    <div>
      <ChangeTemporaryPasswordForm
        lang={lang}
        translation={t}
        token={match.params.token}
        history={history}
      />
    </div>
  )
}

const mapStateToProps = ({ auth }) => ({
  lang: auth.lang
})

const mapDispatchToPros = dispatch => bindActionCreators({ changeTemporaryPassword }, dispatch)

export default connect(mapStateToProps, mapDispatchToPros)(ChangeTemporaryPasswordPage)
